import { CheckoutStateInterface } from '@/models/global-state/index'
const checkoutState: CheckoutStateInterface = {
  isAppLoading: false,
  component: 'login',
  emailOrPasswordError: false,
  userToken: '',
  apiCallTracker: {
    inProgress: false,
    isSuccess: false,
    isError: false,
    isComplete: false,
    response: {}
  },
  widgetLoginDetails: {
    email: '',
    password: '',
    totalPrice: 0,
    purchaseRefId: '',
    purchaseItems: [
      {
        itemName: '',
        itemQuantity: '',
        itemPrice: 0
      }
    ]
  },
  zeroWidgetProps: {
    totalPrice: 0,
    purchaseRefId: '',
    purchaseItems: '',
    merchantId: '',
    apiKey: '',
    country: ''
  },
  isTokenExpired: false,
  checkAccess: true,
  repaymentSchedule: [],
  cardDetails: {
    lastFourDigits: '',
    brand: ''
  },
  walletDetails: {
    balance: 0,
    brand: ''
  },
  checkCardAvailability: 'available',
  redirectUrl: '',
  errorMessage: '',
  baseURL: '',
  paymentInstrumentType: 'CARD',
  customerPortaAddress: ''
}
export default checkoutState
